// extracted by mini-css-extract-plugin
export default {"advertDetailContacts":"c-m_fs","advertDetailContacts__header":"c-m_ft"};